import { Component, OnInit } from '@angular/core';
import { TekstResourcePipe } from 'src/app/core/pipes/tekstresource.pipe';

interface ICardProps {
  title: string;
  description: string;
  imgsrc: string;
  imgalt: string;
  buttontext: string;
  routerlink: string[];
}

@Component({
  selector: 'bom-frontpage',
  templateUrl: './front-page.component.html',
  styleUrls: ['./front-page.component.scss'],
})
export class FrontPageComponent implements OnInit {
  card1: ICardProps;
  card2: ICardProps;
  card3: ICardProps;

  constructor(private tekstResourcePipe: TekstResourcePipe) {}

  ngOnInit(): void {
    this.card1 = {
      title: this.tekstResourcePipe.transform('Forside.Cards.BehoeverDu.Overskrift'),
      description: this.tekstResourcePipe.transform('Forside.Cards.BehoeverDu.Beskrivelse'),
      imgsrc: 'assets/img/forside/BOM_Frontpage3x1_Behøver_jeg_at_ansøge.jpg',
      imgalt: 'Person der tegner',
      buttontext: this.tekstResourcePipe.transform('Forside.Cards.BehoeverDu.KnapTekst'),
      routerlink: ['hjaelp', 'behoever-jeg'],
    };

    this.card2 = {
      title: this.tekstResourcePipe.transform('Forside.Cards.Start.Overskrift'),
      description: this.tekstResourcePipe.transform('Forside.Cards.Start.Beskrivelse'),
      imgsrc: 'assets/img/forside/BOM_Frontpage3x1_Start.jpg',
      imgalt: 'Mursten der bliver lagt',
      buttontext: this.tekstResourcePipe.transform('Forside.Cards.Start.KnapTekst'),
      routerlink: ['projekter', 'nyt', 'ikke-gemt'],
    };

    this.card3 = {
      title: this.tekstResourcePipe.transform('Forside.Cards.Fortsaet.Overskrift'),
      description: this.tekstResourcePipe.transform('Forside.Cards.Fortsaet.Beskrivelse'),
      imgsrc: 'assets/img/forside/BOM_Frontpage3x1_Fortsaet.jpg',
      imgalt: 'Hus set oppe fra',
      buttontext: this.tekstResourcePipe.transform('Forside.Cards.Fortsaet.KnapTekst'),
      routerlink: ['projekter', 'mine'],
    };
  }
}
